export const BulkOperationType = {
    COPY: 'copy',
    MOVE: 'move',
    CHANGE_STATUS: 'changeStatus',
    CHANGE_ASSIGNMENTS: 'changeAssignments',
    DELETE: 'delete',
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/constants.js